import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeviationResourceType } from '../../types/deviation';
import { PapiDeviation } from '@wix/da-papi-types';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiData, TierEditClickBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  className?: string;
  tier: PapiDeviation;
  isOwner: boolean;
  onClick: () => void;
}

const EditTierButton: React.FC<Props> = ({ className, onClick, isOwner, tier }) => {
  const { t } = useTranslation();
  if (!isOwner) {
    return null;
  }
  return (
    <GhostButton
      className={className}
      size="medium"
      variant="edit-purple"
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      biData={BiData<TierEditClickBiEvent>({
        evid: 536,
        typeid: DeviationResourceType.TIER,
        itemid: tier.deviationId,
      })}
      disabled={['deleted', 'pending_deletion'].includes(tier.tier?.state || '')}
    >
      {t('deviationview.tierCard.cta.edit')}
    </GhostButton>
  );
};
EditTierButton.displayName = 'EditTierButton';

export default EditTierButton;
